import {ApiClient} from '@hconnect/apiclient'

import {StockLevelOverwrite} from '../types'

export const StockOverwritesQueryKey = 'stock-overwrites'

export const stockOverwritesQueryOptions = (
  plantCode: string,
  materialId: number,
  from: string,
  to: string
) => ({
  queryKey: [StockOverwritesQueryKey, plantCode, materialId, from, to] as const,
  queryFn: async ({signal}: {signal?: AbortSignal}) => {
    const response = await ApiClient.axiosInstance.get<StockLevelOverwrite[]>(
      `/plants/${plantCode}/material-storage/stock-level/material/${materialId}`,
      {signal, params: {from, to}}
    )
    return response.data
  }
})
